<template>
	<div id='app'>
		<SteamHeader></SteamHeader>
		<not-found v-show='$store.state.show404Page'></not-found>

		<transition name='fade'>
			<router-view v-show='!$store.state.show404Page'></router-view>
		</transition>
		<SteamFooter></SteamFooter>

		<!-- Login -->
		<b-modal id="loginModal" size="lg" hide-header hide-footer>
			<div class="fadeIn">
				<div class="modal-dialog modal-dialog-centered modal-lg">
					<div class="modal-content bgDarkTexture">
						<div class="d-flex flex-column align-items-center justify-content-center m-3 p-xl-2 px-lg-2 py-lg-2 px-5 py-2">
							<div class="align-self-md-end align-self-start noYetRegistered">
								<p class="mb-1">Not a member yet?
									<a href="#" class="text-primary pl-2 bordered-bottom-sm" v-b-modal.registerModal @click="$bvModal.hide('loginModal')">Register Now!<i class="fas fa-chevron-right pl-1"></i></a>
								</p>
							</div>
							<div class="modalMainContentContainer px-lg-5">
								<div class="formularyAccount">
									<h2 class="display-4 bordered-bottom animated slideInLeft fast mt-2">Login</h2>
									<h3 class="h6 pt-1 fontSecondarySmall text-primary animated fadeIn">Log in to your account and start playing right now!</h3>
									<form class="getAuth loginForm">
										<div class="form-group">
											<input type="text" class="form-control my-3 p-3 borderPrimaryColor bg-transparent colorLight" id="login-user" placeholder="==(user_name_txt)==" autocomplete="on" required>
											<input type="password" class="form-control my-3 p-3 borderPrimaryColor bg-transparent colorLight" id="login-pass" placeholder="==(password)==" autocomplete="on" required>
											<div class="row mx-0">
												<div class="form-check col-6">
													<input type="checkbox" class="form-check-input" id="loggedIn" checked="checked">
													<label class="form-check-label" for="loggedIn">Stay connected</label>
												</div>
												<div class="col-6 text-right"><a href="https://en.idcgames.com/extra/forgotten-password" class="text-primary">Forgot your password?</a></div>
											</div>
											<p class="callbackLogin mt-3"></p>
											<button id="login_btn" type="submit" class="btn-cta mt-xl-4 mt-md-2">Login</button>
										</div>
									</form>
								</div>
								<div class="col d-flex flex-column mt-xl-5 pt-2 px-0">
									<div><h4>or start session with:</h4></div>
									<div class="d-flex flex-row flex-wrap align-items-center justify-content-start">
										<button class="btn-google btn-social fontPrimarySmall m-1" data-opt="login">
											<font-awesome-icon :icon="{ prefix: 'fab', iconName: 'google' }" />
											Sign in with <b>Google</b>      
										</button>
										<button class="btn-facebook btn-social fontPrimarySmall m-1" data-opt="login">
											<font-awesome-icon :icon="{ prefix: 'fab', iconName: 'facebook-square' }" />
											Sign in with <b>Facebook</b>      
										</button>
										<button type="button" class="btn-social btn-steam fontPrimarySmall m-1" data-id="steambtnLogin">
											<font-awesome-icon :icon="{ prefix: 'fab', iconName: 'steam-symbol' }" />
											Sign in with <b>STEAM</b>
										</button>
										<button type="button" class="btn-social btn-twitter fontPrimarySmall m-1" data-id="twitterbtnLogin">
											<font-awesome-icon :icon="{ prefix: 'fab', iconName: 'twitter' }" />
											Sign in with <b>Twitter</b>                
										</button>
										<button type="button" class="btn-social btn-yahoo fontPrimarySmall m-1" data-id="yahoobtnLogin">
											<font-awesome-icon :icon="{ prefix: 'fab', iconName: 'yahoo' }" />
											Sign in with <b>Yahoo</b>              
										</button>
										<button type="button" class="btn-social btn-msn fontPrimarySmall m-1" data-id="msnbtnLogin">
											<img src="https://cdn.idcgames.com/img/login/icon-ms-reg.png" class="pr-2" alt="">Sign in with <b>MSN</b>                
										</button>
									</div>
								</div>
								<div class="pt-xl-4 pt-2">
									<!--p class="fontPrimarySmall">==(by_signing_help_1)== <a class="text-primary" href="https://==(language)==.==(domain)==/==(url_legal_conditions)==">==(legal_conditions_txt)==</a>, ==(by_signing_help_2)== <a class="primaryColor" href="https://==(language)==.==(domain)==/==(url_privacy_policy)==">==(privacy_policy_txt)==</a> ==(by_signing_help_3)== <a class="primaryColor" href="https://==(language)==.==(domain)==/==(url_use_of_cookies)==">==(use_of_cookies_txt)==</a> ==(by_signing_help_4)==</p-->
									<p class="fontPrimarySmall">By signing up, I agree to the Legal conditions, the Privacy Policy and the use of cookies of IDC/Games.</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>

		<b-modal id="registerModal" size="lg" hide-header hide-footer>
			<div class="fadeIn">
				<div class="modal-dialog modal-dialog-centered modal-lg">
					<div class="modal-content bgDarkTexture">
						<div class="d-flex flex-column align-items-center justify-content-center m-3 p-xl-2 px-lg-2 py-lg-2 px-5 py-2">
							<div class="align-self-md-end align-self-start noYetRegistered">
								<p class="mb-1">Are you a member?
									<a href="#" class="text-primary pl-2 bordered-bottom-sm" v-b-modal.loginModal  @click="$bvModal.hide('registerModal')">Login now!<i class="fas fa-chevron-right pl-1"></i></a>
								</p>
							</div>
							<div class="modalMainContentContainer px-lg-5">
								<div class="formularyAccount">
									<h2 class="display-4 bordered-bottom animated slideInLeft fast mt-2">New at IDC Games?</h2>
									<h3 class="h6 pt-1 fontSecondarySmall text-primary animated fadeIn">Create your FREE account and start playing right now!</h3>
									<form class="getAuth registerForm">
										<div class="form-group">
											<input type="text" class="form-control my-3 p-3 borderPrimaryColor bg-transparent colorLight" id="register-user" placeholder="==(user_name_txt)==" autocomplete="on" required>
											<div class="row my-3 mx-0">
												<div class="col-6 pr-2 pl-0">
													<input type="password" class="form-control p-md-3 p-2 borderPrimaryColor bg-transparent colorLight" id="register-pass" placeholder="==(password)==" autocomplete="on" required />
												</div>
												<div class="col-6 pl-2 pr-0">
													<input type="password" class="form-control p-md-3 p-2 borderPrimaryColor bg-transparent colorLight" id="register-conf" placeholder="==(confirm_password)==" autocomplete="on" required />
												</div>
											</div>
											<div class="row my-3 mx-0">
												<div class="form-check col-6">
													<input type="checkbox" class="form-check-input" id="registerIn" checked="checked">
													<label class="form-check-label" for="registerIn">Stay connected</label>
												</div>
											</div>
											<p class="callbackLogin mt-3"></p>
											<button id="login_btn" type="submit" class="btn-cta mt-xl-4 mt-md-2">Login</button>
										</div>
									</form>
								</div>
								<div class="col d-flex flex-column mt-xl-5 pt-2 px-0">
									<div><h4>or start session with:</h4></div>
									<div class="d-flex flex-row flex-wrap align-items-center justify-content-start">
										<button class="btn-google btn-social fontPrimarySmall m-1" data-opt="login">
											<font-awesome-icon :icon="{ prefix: 'fab', iconName: 'google' }" />
											Sign in with <b>Google</b>      
										</button>
										<button class="btn-facebook btn-social fontPrimarySmall m-1" data-opt="login">
											<font-awesome-icon :icon="{ prefix: 'fab', iconName: 'facebook-square' }" />
											Sign in with <b>Facebook</b>      
										</button>
										<button type="button" class="btn-social btn-steam fontPrimarySmall m-1" data-id="steambtnLogin">
											<font-awesome-icon :icon="{ prefix: 'fab', iconName: 'steam-symbol' }" />
											Sign in with <b>STEAM</b>
										</button>
										<button type="button" class="btn-social btn-twitter fontPrimarySmall m-1" data-id="twitterbtnLogin">
											<font-awesome-icon :icon="{ prefix: 'fab', iconName: 'twitter' }" />
											Sign in with <b>Twitter</b>                
										</button>
										<button type="button" class="btn-social btn-yahoo fontPrimarySmall m-1" data-id="yahoobtnLogin">
											<font-awesome-icon :icon="{ prefix: 'fab', iconName: 'yahoo' }" />
											Sign in with <b>Yahoo</b>              
										</button>
										<button type="button" class="btn-social btn-msn fontPrimarySmall m-1" data-id="msnbtnLogin">
											<img src="https://cdn.idcgames.com/img/login/icon-ms-reg.png" class="pr-2" alt="">Sign in with <b>MSN</b>                
										</button>
									</div>
								</div>
								<div class="pt-xl-4 pt-2">
									<p class="fontPrimarySmall">By signing up, I agree to the Legal conditions, the Privacy Policy and the use of cookies of IDC/Games.</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
	import SelectButton from './components/SelectButton'
	import {apiDomain} from './config'
	import LoadingButton from './components/LoadingButton'
	import NotFound from './components/routes/NotFound'
	import AjaxErrorHandler from './assets/js/errorHandler'

	import SteamHeader from './components/Header';
	import SteamFooter from './components/Footer';

	export default {
    name: 'app',
		components: {
			NotFound,
			SelectButton,
			SteamHeader,
			SteamFooter,
			LoadingButton
		},
		created(){			
			this.checkUser()

			this.axios.get(`${apiDomain}/api/v1/translation`)
				.then(res => {
					if(res.data.success){
						Object.keys(res.data.data).map(lang => this.$i18n.setLocaleMessage(lang, res.data.data[lang] || {}))
					}
				})
				.catch(this.ajaxErrorHandler)
		},
		data () {
			return {
				signup: {
					username: '',
					password: '',
					confirmPassword: '',
					loading: false,
					errors: {
						username: '',
						hash: '',
						confirmPassword: ''
					}
				},
				login: {
					username: '',
					password: '',

					loading: false,

					errors: {
						username: '',
						hash: ''
					}
				},
				loadingLogout: false,
				ajaxErrorHandler: AjaxErrorHandler(this.$store)
			}
		},
		methods: {
			getIdcToken: function(){
				try{
					let str = document.cookie.split(';').filter( x => x.includes('token=') && x.length >= 800 )[0];	
					return str.split('token=')[1];
				}catch(error){
					console.log(error);
					return false;
				}
			},
			//login
			checkUser : function(){								
				this.login.loading = true

				if(apiDomain.includes('localhost')){
					let nick  = 'Mjolinr';
					let id 	  = '366819';
					let token = 'Z0ZNWENQYVlDTFBNT2NxN1RqYm1Fb0hOZ2FQYnNZRFR1VTVkempnbkx2Y3lMc09QRGtaQzQ3MW9jTFBKMGtVQ0dNeUVmRExYTzVJRGo2UGE4Umg3VHZwYjNXbzBVWVZmUXBQQlBKWkNoNjNZclkzRVZyZmFJZTVVMXB3ZldCZDY0NXJjZm5uMVI1Y3FLbkRxUVA4Nk8xak51cFhKR3V3dUpvTnpHeWVTWENUZUo4Q0x5dmJJcVVzNm9WbFM3dEZ0aUNuQ2tuYTVzOE5OUlZ4SmQydVNQZG9vT09qUDBvNFdrSEw0d2dlRE4xSDVuSER2Uy9kbjdQVUlCaVBvS0t6elBQUDFNQ3ZvcGpiWHU5SFpuZitqVUh4WnVVaHV0NE1uY2oxUWM2eXpERERaUTNJekt0UkxkT21SWHRieVNzanZoUlBEd1VTbStOdVdzenZiazJTN29SNGFlaVF0RzY1UlEvVFdhdHI2VEd5OGVpbUxPd2dhSkNWNFhpbDF0TE01bmptM3YvR1oxUEJIWHd6Ris0RnFrWDA3c2FIYy9rekYrQ0syV0xndUk1RVZaU2xGK2g1TzgyVUMrcEJtbDdxQmd5N2JiRGJVY1ZERlBOS3ZhSDdvb2N4MHhtakl6UUVkQ3pRckhpbWpWUWthUDBHRWxmTGpQK1QyeXU4WHpVQXZ5djY1TzBXTXl6WmF3S0pJMEdwdDNvbmE1bGpoVUFna3RLNVdyZ2NFY0JyYkFNYXp1blBHSTNUMTBuQ2NGMXZOaitsVXo2d1IvY1lEU3NQcjU1MWprMVFCVlJwSlFlTk50c2FxVE1JWnJWOD0=';
					
					this.$cookies.set('id', id);
					this.$cookies.set('nick', nick);
					this.$cookies.set('token', token);
				}else{
					var idcToken = this.$cookies.get('token');

					if( !idcToken || (idcToken && idcToken.length < 800) ){
						idcToken = this.getIdcToken();
						this.$cookies.set('token', idcToken);
					}					
				}			

				this.axios.post(`${apiDomain}/api/v1/login`, {
					useridc: this.$cookies.get('id'),
					nickname: this.$cookies.get('nick'),
					idctoken: this.$cookies.get('token')
				})
				.then(res => {
					this.login.loading = false
					this.$store.commit('setProfile_photo_path', res.data.data.profile_photo_path)
					this.$store.commit('setUsername', res.data.data.nickname)
					this.$store.commit('setEmail', res.data.data.email)
					this.$store.commit('setAdmin', res.data.data.admin)
					this.$store.commit('setRole', res.data.data.role)
					this.$store.commit('setUserID', res.data.data.user_id)
					this.$store.commit('setPoints', res.data.data.point)
					this.$store.commit('setLevel', res.data.data.level)
					this.$store.commit('setWin', res.data.data.win)
					this.$store.commit('setNmessages', res.data.data.message)
					
					this.$cookies.set('authtoken', res.data.data.authtoken)
										
				}).catch(e => {
					
					this.login.loading = false
					this.$store.commit('setProfile_photo_path', '')
					this.$store.commit('setUsername', '')
					this.$store.commit('setEmail', '')
					this.$store.commit('setAdmin', null)
					this.$store.commit('setRole', '')
					this.$store.commit('setUserID', '')
					this.$store.commit('setPoints', '')
					this.$store.commit('setLevel', '')
					this.$store.commit('setWin', 0)
					this.$store.commit('setNmessages', '')
					
					this.$cookies.set('authtoken', '')

					this.ajaxErrorHandler(e, (error) => {
						let path = error.path
							if(this.signup.errors[path] !== undefined && this.signup.errors[path] !== undefined) {
								this.signup.errors[path] = error.message
							}
						}
					)
				})
			}
		},
		watch: {
			$route () {},
		}
	}
</script>

<style lang='scss'>
	@import './assets/scss/variables.scss';
	@import './assets/scss/elementStyles.scss';
	@import './assets/scss/nprogress.scss';
	@import './assets/scss/idec.scss';

	html, body {
		width: 100%;
		margin: 0;
		padding: 0;
		color: #fff;
		line-height: 1.5;
		background-color: #13181d;
		@include text;
	}

	* {
		box-sizing: border-box;
	}

	#app {
		height: 100%;
	}

	.dropdown-menu.show{
		background-color: #000;
	}
	.dropdown-menu:focus{
		outline: none;
	}

	.header {
		background-repeat: repeat;
		padding: 0.6rem 2rem;
		border-bottom: 1px solid #00ff7f;
		width: 100%;
		position: fixed;
		top: 0;
		z-index: 2;
		display: flex;
		align-items: center;
		justify-content: space-between;
		background-color: #000;
		background-image: url("../src/assets/img/textures/noisy_net.png");

		@at-root #{&}__group {
			display: flex;
			align-items: center;
			justify-content: space-between;
			.first_header_group {
				> * { margin: 0 0.5rem; }
				> *:first-child { margin-left: 0; }
				> *:last-child { margin-right: 0; }
			}
		}

		@at-root #{&}__menu_button {
			position: fixed;
			left: 1rem;
			z-index: 1;
			font-size: 1.5rem;
			top: 1rem;
			display: none;
		}

		@at-root #{&}__overlay {
			width: 100%;
			height: 100%;
			position: fixed;
			top: 0;
			left: 0;
			z-index: 1;
			pointer-events: none;
			opacity: 0;
			background-color: hsla(215, 13%, 25%, 0.5);
			transition: all 0.4s;
		}
	}

	.header__menu_button {
		position: fixed;
		left: 0.8rem;
		z-index: 1;
		font-size: 1.5rem;
		top: 0.5rem;
		display: none;
	}

	@media (max-width: 870px) {
		.route_container {
			margin-top: 0rem;
		}

		.header__menu_button {
			display: inline-block;
			cursor: pointer;
		}

		.header__overlay--show {
			pointer-events: all;
			opacity: 1;
		}

		.header{
			border-bottom: 0;

			.header__group {
				position: fixed;
				width: 20rem;
				display: flex;
				justify-content: flex-start;
				flex-direction: column;
				z-index: 2;
				background-image: linear-gradient(45deg, springgreen 1%, #314954 50%, #1b1d2c 100%);
				top: 0;
				left: calc(-100% - 2rem);
				height: 100%;
				box-shadow: none;
				transition: left 0.4s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.4s ease-in;

				> .button {
					width: 100%;
					border-radius: 0;
					margin: 0;
					margin-bottom: 1rem;
				}

				&::before {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 0.3rem;
					content: '';
					background: linear-gradient(to right, hsl(200, 98%, 43%), hsla(193, 98%, 48%, 1));
				}

				.first_header_group {
					> * { margin: 0.5rem; }
				}
			}
		}		

		.btn-group, .btn-group-vertical{
			display: block!important;
		}

		.first_header_group{
			padding-top: 2rem;
			text-align: center;
			padding-bottom: 1.5rem;
		}

		.header__group.header__group--show {
			left: 0;
			box-shadow: 0 0 1rem rgba(0, 0, 0, 0.4);
		}
	}

/* >> */
.game-card-rectangular img {
    -o-object-fit: cover;
    object-fit: cover;
    height: 76px; 
}
.game-card-rectangular {
  -webkit-transition: all .1s ease-in-out;
  transition: all .1s ease-in-out;
  cursor: pointer; }
.game-card-rectangular .cart-btn {
	display: none; }
.game-card-rectangular span.h6.text-shadow.mb-0 {
	margin-top: -4px; }
.game-card-rectangular:hover {	
	transition: all .1s ease-in-out; }
.game-card-rectangular:hover .cart-btn {
	display: block; }
.game-card-rectangular:hover .card-img-overlay {
	padding: .25rem;
	-webkit-transition: all ease-out .4s;
	transition: all ease-out .4s; }
.game-card-rectangular:hover .logo-img-container {
	background-image: radial-gradient(circle, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.5));
	-webkit-transition: all .1s ease-in-out;
	transition: all .1s ease-in-out; }  
.game-card-rectangular .bg-img-container {
	height: 76px;
	width: 152px; }
.game-card-rectangular .logo-img-container {
	-webkit-transition: all .1s ease-in-out;
	transition: all .1s ease-in-out; }
.game-card-rectangular .card-img-overlay {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	padding: .5rem;
	width: 100% }
</style>
<style>
.notices.is-bottom{
	height: 160px;
}
</style>
